(function () {
  const BUNDLE_SELECTORS =
    'input[name="cb"], input[type="radio"][name="cb"]';
  const BUNDLE_ANCHOR_SELECTORS =
    '.template_4_block_wrapper, .block__cb, [class*="prvw_bundle"]';
  // Conteneur global du widget bundle (app Pumper) : on cible son haut pour
  // atterrir sur le tout début du sélecteur, titre et badges compris.
  const BUNDLE_CONTAINER_SELECTORS =
    'pumper-bundle, #prvw__bundle_container, [id^="prvw"][id*="bundle"]';

  function getHeaderOffset() {
    let offset = 0;

    const announcement = document.querySelector('.announcement-bar-section');
    const header = document.querySelector(
      '.shopify-section-header-sticky, .section-header'
    );

    if (announcement) {
      offset += announcement.offsetHeight;
    }

    if (header) {
      offset += header.offsetHeight;
    }

    // Marge supplémentaire pour que la 1re option bundle reste visible sous le header
    offset += window.matchMedia('(max-width: 749px)').matches ? 32 : 16;

    return offset;
  }

  function findBundleAnchor() {
    // On privilégie le conteneur complet du widget pour scroller sur le haut
    // du sélecteur de bundle plutôt que sur la 1re option seule.
    const container = document.querySelector(BUNDLE_CONTAINER_SELECTORS);
    if (container && container.isConnected) return container;

    const radio = document.querySelector(BUNDLE_SELECTORS);
    if (!radio) return null;

    return (
      radio.closest('[class*="prvw_bundle"]') ||
      radio.closest(BUNDLE_ANCHOR_SELECTORS) ||
      radio.closest('[class*="prvw"]')
    );
  }

  function findAtcButton(sectionId) {
    return (
      document.getElementById(`ProductSubmitButton-${sectionId}`) ||
      document
        .querySelector(`#MainProduct-${sectionId}, [data-section="${sectionId}"]`)
        ?.querySelector('.product-form__submit')
    );
  }

  function isAtcPassed(atcButton) {
    const rect = atcButton.getBoundingClientRect();
    return rect.bottom < getHeaderOffset();
  }

  function scrollToBundle(anchor) {
    if (!anchor) return;
    const top =
      anchor.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
    window.scrollTo({ top, behavior: 'smooth' });
  }

  class FloatingBundleCta extends HTMLElement {
    connectedCallback() {
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
      }

      this.button = this.querySelector('.floating-bundle-cta__button');
      this.sectionId = this.dataset.sectionId;
      this.mutationObserver = null;
      this.onScroll = this.updateVisibility.bind(this);

      this.button?.addEventListener('click', this.onClick.bind(this));
      this.initWhenReady();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.mutationObserver?.disconnect();
    }

    initWhenReady() {
      const anchor = findBundleAnchor();
      const atcButton = findAtcButton(this.sectionId);

      if (!anchor || !atcButton) {
        this.setupLateInit();
        return;
      }

      this.bundleAnchor = anchor;
      this.atcButton = atcButton;
      this.setupVisibilityTracking();
    }

    setupLateInit() {
      const root =
        document.querySelector(`#MainProduct-${this.sectionId}`) ||
        document.querySelector('main');

      if (!root) return;

      this.mutationObserver = new MutationObserver(() => {
        const anchor = findBundleAnchor();
        const atcButton = findAtcButton(this.sectionId);
        if (anchor && atcButton) {
          this.mutationObserver?.disconnect();
          this.bundleAnchor = anchor;
          this.atcButton = atcButton;
          this.setupVisibilityTracking();
        }
      });

      this.mutationObserver.observe(root, { childList: true, subtree: true });
    }

    setupVisibilityTracking() {
      this.updateVisibility();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
    }

    updateVisibility() {
      if (!this.atcButton) return;
      this.setVisible(isAtcPassed(this.atcButton));
    }

    setVisible(visible) {
      this.classList.toggle('is-visible', visible);
      if (visible) {
        this.removeAttribute('hidden');
      } else {
        this.setAttribute('hidden', '');
      }
    }

    onClick() {
      // On ré-interroge le DOM à chaque clic : l'app bundle re-render son
      // markup, donc une ancre mise en cache à l'init peut être détachée
      // (getBoundingClientRect renverrait 0 et le scroll ne mènerait nulle part).
      const anchor = findBundleAnchor();
      const cached =
        this.bundleAnchor && this.bundleAnchor.isConnected
          ? this.bundleAnchor
          : null;
      scrollToBundle(anchor || cached);
    }
  }

  if (!customElements.get('floating-bundle-cta')) {
    customElements.define('floating-bundle-cta', FloatingBundleCta);
  }
})();
